import { TQuestionBook } from '../../../Questions/components/QuestionsContent/types'
import Modal from '../Modal'
import { Container } from './styles'
import { GrFormClose } from 'react-icons/gr'

interface IProps {
  questionBook: TQuestionBook
  isOpen: boolean
  onClose(): void

  onCopyClick(): void
  onRenameClick(): void
  onDeleteClick(): void
  onPrintClick(): void
  disabledPrintPdf: boolean
}

const ActionsModal = (props: IProps) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <Container>
        <button className="close" onClick={props.onClose}>
          <GrFormClose size="100%" />
        </button>

        <p className="name">{props.questionBook.name}</p>

        <div className="infos">
          <span className="info">{props.questionBook.totalPublicTenders} órgãos • </span>{' '}
          <span className="info">{props.questionBook.totalSubjects} disciplinas • </span>{' '}
          <span className="info">{props.questionBook.totalThemes} assuntos • </span>{' '}
          <span className="info">{props.questionBook.totalQuestions} questões</span>
        </div>

        <div className="buttons">
          <button onClick={props.onRenameClick}>Editar nome</button>
          <button onClick={props.onCopyClick}>Copiar caderno</button>
          <button onClick={props.onPrintClick}>Imprimir/Gerar PDF</button>
          <button disabled={props.disabledPrintPdf} onClick={props.onDeleteClick}>
            Excluir caderno
          </button>
        </div>
      </Container>
    </Modal>
  )
}

export default ActionsModal
